module.exports = __webpack_public_path__ + "img/weddingRingsFacettedConnections-emotion-02@2x.678dc9d.webp";